import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { ResetPassword, ResetPasswordParams } from './model';
import { ResetPasswordView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function ResetPasswordRoute (
    model : (params : ResetPasswordParams) => ResetPassword,
    appWrapper : AppWrapper,
    request : Location
) {
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <ResetPasswordView model={model(inboundParams(request))} />
            </AppWrapperView>
    };
}

function inboundParams(request : Location) : ResetPasswordParams {
    return {
        userId: +(request.params['userId'] || 0),
        token: request.params['token'] || ''
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/resetpassword/route.tsx